<template>
    <div>
        <slot />

        <b-table
            striped
            hover
            :items="filteredItems"
            :fields="fields"
            responsive
        >
            <!--  No, Name, Details, UOM, Qty, Price, Tax , Total 
 -->
            <template #cell(id)="{ item: { hash } }">
                <b-button-group size="sm">
                    <b-button
                        variant="primary"
                        @click="$emit('view-item', hash)"
                        >Select</b-button
                    >
                    <b-button
                        @click="deleteItem(hash)"
                        v-if="hasPermissionDelete && !order.completed"
                        class="ml-2"
                        variant="warning"
                    >
                        Delete
                    </b-button>
                </b-button-group>
            </template>

            <template #cell(index)="data">
                {{ data.index + 1 }}
            </template>

            <!-- <template #cell(order_item_type_id)="data">
                {{ data.value | displayTypeName(itemTypes) }}
            </template> -->

            <template
                #cell(details)="{
                    item: { description, task_notes, task_value, assets },
                }"
            >
                <span v-if="!!description" style="font-weight: bold">
                    {{ description }}
                </span>
                <ul class="dashed">
                    <li v-if="task_notes">
                        Notes:
                        <span style="font-weight: bold"> </span>
                        {{ task_notes }}
                    </li>
                    <li v-if="task_value">
                        Value:
                        <span style="font-weight: bold"> </span>
                        {{ task_value }}
                    </li>

                    <li
                        v-if="assets && assets.length"
                        v-html="displayAssets(assets)"
                    ></li>
                </ul>
            </template>

            <template #cell(price)="data">
                <p class="text-right">
                    {{ data.value | currency }}
                </p>
            </template>

            <template #cell(tax)="data">
                <p class="text-right">
                    {{ calculateItemTax(data.item) | currency }}
                </p>
            </template>

            <template #cell(total)="data">
                <p class="text-right">
                    {{ calculateItemCost(data.item) | currency }}
                </p>
            </template>

            <template #cell(task_checked)="data">
                <b-form-checkbox
                    value="1"
                    unchecked-value="0"
                    :checked="data.value"
                    disabled
                >
                </b-form-checkbox>
            </template>
            <template #cell(task_notes)="data">
                <p class="text-right">
                    {{ data.value }}
                </p>
            </template>
        </b-table>
    </div>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'

export default {
    name: 'orders-displayOrderItems',
    data: () => ({
        criteria: null,
        type: null,
        isAssignment: true,
        text: 'Sample Text',
    }),
    props: ['filteredItems', 'customerAssets', 'itemTypeId'],
    mixins: [popupMixins, permissionsMixins],
    filters: {
        displayTypeName(id, itemTypes) {
            return (itemTypes.find(x => x.id == id) || {}).name
        },

        formatLocation(s) {
            s = s || {}
            s.location = s.location || {}
            return `${s.name}, ${s.location.address1}, ${s.location.city}`
        },

        currency: num => {
            num = parseFloat(num)
            try {
                return num.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
            } catch (err) {
                return '0.00'
            }
        },
        capitalize: function (value) {
            if (!value) return ''
            value = value.toString()
            return value.charAt(0).toUpperCase() + value.slice(1)
        },
    },
    computed: {
        order() {
            const order = this.$store.state.orders.item

            return { ...(order || {}) }
        },

        itemTypes() {
            return this.$store.state.itemType.items
        },

        options() {
            return [
                { text: 'Assignment', value: true },
                { text: 'Check-Off', value: false },
            ]
        },
        fields() {
            console.log(
                '---------------------------------------------------------- '
            )
            /*
>>>> When I select product (is order item?) It should display No, Name, Details, UOM, Qty, Price, Tax , Total

When I select services ( is order item and task type) it should display:
 No, Name, Details , UOM, QTY, Price, Tax , Total, Check mark if completed, add a description field and put measurement name, value, and any notes if anything is contained in the field

When I select task (task type) it should display No, Name, Details , Check mark if completed, add a description field and put measurement name, value, and any  notes if anything is contained in the field

            */

            const _fields = [
                { key: 'id', label: '', stickyColumn: true },
                { key: 'index', label: 'No' },
                { key: 'name', label: 'Name' },
                { key: 'details', label: 'Details' },
            ]
            const product_fields = [
                { key: 'uom', label: 'UOM' },
                { key: 'quantity', label: 'Qty' },
                {
                    key: 'price',
                    label: 'Price',
                    thClass: 'text-right',
                    tdClass: 'text-right',
                },
                {
                    key: 'tax',
                    label: 'Tax',
                    thClass: 'text-right',
                    tdClass: 'text-right',
                },
                {
                    key: 'total',
                    label: 'Total',
                    thClass: 'text-right',
                    tdClass: 'text-right',
                },
            ]
            const service_fields = [
                { key: 'uom', label: 'UOM' },
                { key: 'quantity', label: 'Qty' },
                {
                    key: 'price',
                    label: 'Price',
                    thClass: 'text-right',
                    tdClass: 'text-right',
                },
                {
                    key: 'tax',
                    label: 'Tax',
                    thClass: 'text-right',
                    tdClass: 'text-right',
                },
                {
                    key: 'total',
                    label: 'Total',
                    thClass: 'text-right',
                    tdClass: 'text-right',
                },
                {
                    key: 'task_checked',
                    label: 'Completed',
                    thClass: 'text-right',
                    tdClass: 'text-right',
                },
                /* {
                    key: 'task_notes',
                    label: 'Notes',
                    thClass: 'text-right',
                    tdClass: 'text-right',
                },*/
            ]
            const task_fields = [
                /* {
                    key: 'price',
                    label: 'Price',
                    thClass: 'text-right',
                    tdClass: 'text-right',
                },
                {
                    key: 'tax',
                    label: 'Tax',
                    thClass: 'text-right',
                    tdClass: 'text-right',
                },*/
                {
                    key: 'original_quantity',
                    label: 'Quantity',
                    thClass: 'text-right',
                    tdClass: 'text-right',
                },
                {
                    key: 'task_checked',
                    label: 'Completed',
                    thClass: 'text-right',
                    tdClass: 'text-right',
                },
                /*  {
                    key: 'task_notes',
                    label: 'Notes',
                    thClass: 'text-right',
                    tdClass: 'text-right',
                },*/
            ]

            //const type = this.itemTypes.find(x => x.id === this.itemTypeId)
            if (this.isTask(this.itemTypeId)) {
                _fields.push(...task_fields)
            }
            if (this.isProduct(this.itemTypeId)) {
                _fields.push(...product_fields)
            }
            if (this.isService(this.itemTypeId)) {
                _fields.push(...service_fields)
            }

            return _fields
            // return product_fields
        },
    },
    watch: {
        isAssignment: function (val) {
            this.$emit('toggleAssignment', !val)
        },
        order: {
            handler: function (_order) {
                console.log('computed---order', _order)
                //Emit Order Completeion Status
                this.$emit('order-status', _order.completed)
                console.log('computed---order--status', _order.completed)
            },
            deep: true,
        },
    },
    mounted() {
        this.$nextTick().then(() => {
            this.$emit('toggleAssignment', !this.isAssignment)
        })
    },
    methods: {
        deleteItem(hash) {
            this.$store.dispatch('orderItemStore/delete', hash)
        },

        calculateItemCost(item) {
            const type =
                this.itemTypes.find(x => item.order_item_type_id === x.id) || {}

            return (
                (type.is_discount ? -1 : 1) *
                (parseFloat(item.price) || 0) *
                (parseFloat(item.quantity) || 0)
            )
        },

        calculateItemTax(item) {
            const type =
                this.itemTypes.find(x => item.order_item_type_id === x.id) || {}

            let itemCost =
                (type.is_discount ? -1 : 1) *
                (parseFloat(item.price) || 0) *
                (parseFloat(item.quantity) || 0)
            return (itemCost * (parseFloat(item.tax_rate) || 0)) / 100
        },

        displayAssets(ids) {
            // x.name + ' ' + x.serial_no,
            const { customerAssets } = this
            const assets = ids
                .map(id => customerAssets.find(asset => asset.id == id))
                .filter(x => !!x)

            const _html = assets.reduce((_str, asset, idx, _list) => {
                const { name, serial_no } = asset
                if (idx === 0) {
                    _str = `<b>Asset${_list.length > 0 ? 's' : ''}:</b> `
                }
                _str += `<br/>${idx + 1}&#58; ${name}${
                    serial_no ? '-' + serial_no : ''
                }`
                return _str
            }, '')
            return _html
        },

        isProduct(itemTypeId) {
            const type = this.itemTypes.find(x => itemTypeId === x.id) || {}
            return type.is_order_item == 1 && type.is_task == 0
        },
        isService(itemTypeId) {
            const type = this.itemTypes.find(x => itemTypeId === x.id) || {}
            return type.is_order_item == 1 && type.is_task == 1
        },
        isTask(itemTypeId) {
            const type = this.itemTypes.find(x => itemTypeId === x.id) || {}
            return type.is_order_item == 0 && type.is_task == 1
        },
    },
}
</script>

<style scoped>
ul {
    margin: 0;
}
ul.dashed {
    list-style-type: none;
}
ul.dashed > li {
    text-indent: -30px;
}
ul.dashed > li:before {
    content: '';
    text-indent: -30px;
}
</style>
